import script from "./PropertyTradeNetworkScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./PropertyTradeNetworkScreen.vue?vue&type=script&setup=true&lang=js"

import "./PropertyTradeNetworkScreen.vue?vue&type=style&index=0&id=bb8a9148&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bb8a9148"]])

export default __exports__